import React from 'react';
import { RootBoxEffectContext } from './root-box-effect-context';
export const useRootBoxEffect = () => React.useContext(RootBoxEffectContext);
//# sourceMappingURL=use-root-box-effect.js.map